import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import { fieldsType } from "@/utils/types/field";
import BaseFieldDetail from "./detail";
import BaseFieldEdit from "./edit";
import BaseFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type Base en: </b>
 * <li>Liste</li>
 * <li>Détails</li>
 * <li>Édition</li>
 */
export function Base() {
    return _jsx(_Fragment, { children: "Base" });
}
var field = fieldsType.base;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, BaseFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, BaseFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, BaseFieldList);
